module.exports = __webpack_public_path__ + "static/media/Restaurant Menu Menu Items.200ce1a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Restaurant Menu Menu Items.png
// module id = 1193
// module chunks = 0